import React from "react";
import moment from "moment";
import "../liveTable.css";

const LiveDataTable = ({
  data,
  headers,
  headerClick,
  sorting,
  subscribeClick,
}) => {
  function getDataClass(data, header) {
    let dataClass = "text-center text-nowrap";
    if (header.SEPERATOR) dataClass += " seperator";
    if (isNaN(data[header.CODE])) return dataClass;
    if (!data[header.CODE]) return dataClass;
    if (header.UPPER_CHECK !== null && data[header.CODE] > header.UPPER_CHECK)
      dataClass += " table-danger";
    if (header.LOWER_CHECK !== null && data[header.CODE] < header.LOWER_CHECK)
      dataClass += " table-danger";
    return dataClass;
  }

  const displayData = [...data];
  if (!sorting) displayData.reverse();

  function isBlank(value) {
    return (value === null || value === undefined || value === '');
  }

  return (
    <div className="table-wrapper">
      <div className="table-scroller">
        <table className="table bordered table-sm table-data">
          <thead className="text-center">
            <tr>
              <th className="sticky-col-1" />
              <th className="sticky-col-2" />
              {headers.map((header) => (
                <th
                  key={header.CODE}
                  className={ header.SEPERATOR ? "text-nowrap lt_TableHeading seperator" : "text-nowrap lt_TableHeading" }
                  style={{valign: "top" }}
                >
                  <div>
                    <button
                      className="btn btn-link"
                      onClick={() => headerClick(header)}
                    >
                      {header.HEADING1}
                    </button>
                  </div>
                  <div>
                    {!isBlank(header.CCFLABEL)
                      ? header.CCFLABEL === 'Pending Close'
                        ? <div className="badge badge-primary">{header.CCFLABEL}</div>
                        : <div className="badge badge-warning">{header.CCFLABEL}</div>
                      : <div />
                    }
                  </div>
                </th>
              ))}
            </tr>
            <tr>
              <th className="text-left sticky-col-1">Date</th>
              <th className="text-left sticky-col-2">Hour</th>
              {headers.map((header) => (
                <th
                  key={header.CODE}
                  className={
                    header.SEPERATOR ? "text-nowrap seperator" : "text-nowrap"
                  }
                >
                  <button
                    className="btn btn-link"
                    onClick={() => headerClick(header)}
                  >
                    {header.HEADING2}
                  </button>
                </th>
              ))}
            </tr>
            <tr>
              <th className="text-left sticky-col-1" />
              <th className="text-left sticky-col-2" />
              {headers.map((header) => (
                <th
                  key={header.CODE}
                  className={
                    header.SEPERATOR ? "text-nowrap seperator" : "text-nowrap"
                  }
                >
                  <button
                    className="btn btn-link"
                    onClick={() => headerClick(header)}
                  >
                    {header.HEADING3}
                  </button>
                </th>
              ))}
            </tr>
            <tr>
              <th className="text-left sticky-col-1" />
              <th className="text-left sticky-col-2" />
              {headers.map((header) => (
                <th
                  key={header.CODE}
                  className={
                    header.SEPERATOR ? "text-nowrap seperator" : "text-nowrap"
                  }
                >
                  {header.TYPE_ID === "REA" ? (
                    <button
                      className="btn btn-link"
                      onClick={() => subscribeClick(header)}
                    >
                      <div className="fas fa-bell text-secondary"></div>
                    </button>
                  ) : null}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {displayData.map((record) => (
              <tr key={record.PARAM_DATE + record.HOUR}>
                <td className="text-left sticky-col-1">
                  {moment.utc(record.PARAM_DATE).format("Do MMM")}
                </td>
                <td className="text-left sticky-col-2">{record.HOUR}</td>
                {headers.map((header) => (
                  <td
                    key={header.CODE}
                    className={getDataClass(record, header)}
                  >
                    {record[header.CODE]
                      ? record[header.CODE].toFixed(header.PRECISION)
                      : record[header.CODE]}
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default LiveDataTable;
